import { useReturnableItems as useReturnableItemsQuery } from "../queries/use-returnable-items";
import type { OrderLineItem } from "../types";

export function useReturnableItems(
  orderId: string,
  shopSlug: string,
): OrderLineItem[] {
  return useReturnableItemsQuery(orderId, shopSlug);
}
